module.exports = __webpack_public_path__ + "static/media/signal-energy.60d3d0f3.png";